/*
 * @Author: EdwardYoung
 * @Date: 2017-07-26 14:26:14
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-09-04 10:41:36
 */

import axios from 'api/axios.js'
import {createApiHeader} from './createApiHeader.js'

function bargainRecords (id) {
  return new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        createApiHeader(axios, User.res.customer)
        _bargainRecords(id).then((res) => {
          resolve(res.data)
        })
      })
    })
  })
}

/**
 * 拉取砍价记录
 */
function _bargainRecords (id) {
  const activityInfUrl = `/v1/front/help_records/${id}`
  return axios({
    method: 'GET',
    url: activityInfUrl
  })
}

export {bargainRecords}



// WEBPACK FOOTER //
// ./src/api/bargainRecords.js